// extracted by mini-css-extract-plugin
module.exports = {"iconsBar":"IconsBar_iconsBar__2wvcw","activeIcon":"IconsBar_activeIcon__52cCh"};